/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Southern Wind Warehouse API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  NoticeOut,
  ProblemDetail
} from '../../model';

import { apiRequest } from '../../../http';
import type { ErrorType } from '../../../http';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Мои непрочитанные уведомления об исправлениях
 */
export const noticesListNotices = (
    
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<NoticeOut[]>(
      {url: `/api/v1/notices`, method: 'GET', ...(signal ? { signal }: {})
    },
      options);
    }
  



export const getNoticesListNoticesQueryKey = () => {
    return [
    `/api/v1/notices`
    ] as const;
    }

    
export const getNoticesListNoticesQueryOptions = <TData = Awaited<ReturnType<typeof noticesListNotices>>, TError = ErrorType<ProblemDetail>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof noticesListNotices>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNoticesListNoticesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof noticesListNotices>>> = ({ signal }) => noticesListNotices(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof noticesListNotices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type NoticesListNoticesQueryResult = NonNullable<Awaited<ReturnType<typeof noticesListNotices>>>
export type NoticesListNoticesQueryError = ErrorType<ProblemDetail>


export function useNoticesListNotices<TData = Awaited<ReturnType<typeof noticesListNotices>>, TError = ErrorType<ProblemDetail>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof noticesListNotices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof noticesListNotices>>,
          TError,
          Awaited<ReturnType<typeof noticesListNotices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNoticesListNotices<TData = Awaited<ReturnType<typeof noticesListNotices>>, TError = ErrorType<ProblemDetail>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof noticesListNotices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof noticesListNotices>>,
          TError,
          Awaited<ReturnType<typeof noticesListNotices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useNoticesListNotices<TData = Awaited<ReturnType<typeof noticesListNotices>>, TError = ErrorType<ProblemDetail>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof noticesListNotices>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Мои непрочитанные уведомления об исправлениях
 */

export function useNoticesListNotices<TData = Awaited<ReturnType<typeof noticesListNotices>>, TError = ErrorType<ProblemDetail>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof noticesListNotices>>, TError, TData>>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNoticesListNoticesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary «Понятно» — уведомление больше не показывается
 */
export const noticesAcknowledge = (
    correctionId: number,
 options?: SecondParameter<typeof apiRequest>,signal?: AbortSignal
) => {
      
      
      return apiRequest<void>(
      {url: `/api/v1/notices/${correctionId}/acknowledge`, method: 'POST', ...(signal ? { signal }: {})
    },
      options);
    }
  


export const getNoticesAcknowledgeMutationOptions = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof noticesAcknowledge>>, TError,{correctionId: number}, TContext>, request?: SecondParameter<typeof apiRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof noticesAcknowledge>>, TError,{correctionId: number}, TContext> => {

const mutationKey = ['noticesAcknowledge'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof noticesAcknowledge>>, {correctionId: number}> = (props) => {
          const {correctionId} = props ?? {};

          return  noticesAcknowledge(correctionId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type NoticesAcknowledgeMutationResult = NonNullable<Awaited<ReturnType<typeof noticesAcknowledge>>>
    
    export type NoticesAcknowledgeMutationError = ErrorType<ProblemDetail>

    /**
 * @summary «Понятно» — уведомление больше не показывается
 */
export const useNoticesAcknowledge = <TError = ErrorType<ProblemDetail>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof noticesAcknowledge>>, TError,{correctionId: number}, TContext>, request?: SecondParameter<typeof apiRequest>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof noticesAcknowledge>>,
        TError,
        {correctionId: number},
        TContext
      > => {

      const mutationOptions = getNoticesAcknowledgeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    